/** Retorna true se o elemento participa do layout visível (não está oculto por CSS). */
export function isOnboardingTargetVisible(element: Element): boolean {
  if (!(element instanceof HTMLElement)) {
    return false;
  }

  const rect = element.getBoundingClientRect();
  if (rect.width < 1 || rect.height < 1) {
    return false;
  }

  let current: HTMLElement | null = element;
  while (current) {
    const style = window.getComputedStyle(current);
    if (style.display === 'none' || style.visibility === 'hidden') {
      return false;
    }
    current = current.parentElement;
  }

  return true;
}

/** Preferência pelo alvo visível quando há duplicata (ex.: footer desktop/mobile). */
export function queryOnboardingTargetElement(targetId: string): Element | null {
  const nodes = document.querySelectorAll(`[data-onboarding-target="${targetId}"]`);
  if (nodes.length === 0) {
    return null;
  }

  for (const node of nodes) {
    if (isOnboardingTargetVisible(node)) {
      return node;
    }
  }

  return nodes[0];
}

export function isOnboardingModalFooterTarget(element: Element): boolean {
  return (
    element.closest('[data-onboarding-modal]') !== null &&
    element.closest('[data-onboarding-modal-scroll]') === null
  );
}
